const labelBySubscription = (planCode) => {
  const subscriptionLabels = {
    fffvipa: 'Annual Subscription',
    fffvip: 'Seasonal Subscription',
    ffftrial: 'Trial SGTF',
    fffsocial: 'Social Subscription',
  };
  return subscriptionLabels[planCode];
};

export {
  labelBySubscription,
};
